<template>
  <MaskComponent dialogType="rule" v-show="$bus.ruleDialogShow">
    <div class="dialog-rule">
      <div class="dialog-rule-title">{{ $bus.transify['FESTA_RULE'] }}</div>
      <div class="dialog-rule-content" v-html="$bus.ruleDialogContent"></div>
    </div>
  </MaskComponent>
</template>

<script>
import MaskComponent from '@/components/base/mask'

export default {
  components: {
    MaskComponent
  }
}
</script>

<style lang="scss" scoped>
.dialog-rule-title {
  text-align: center;
  color: #FFCE3B;
  @include px2res(font-size, 36);
  @include px2res(padding-bottom, 20);
  font-family: $main-font-family;
}

.dialog-rule-content {
  @include px2res(height, 370);
  @include px2res(padding-top, 10);
  overflow: auto;
  color: $white;
  text-transform: none !important;

  & /deep/ p,
  & /deep/ span {
    line-height: 1.4em !important;
  }

  & /deep/ p,
  & /deep/ span {
    font-family: $main-font-family !important;
    @include px2res(font-size, 30, '!important');
  }

  & /deep/ img {
    max-width: 100% !important;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/dialog/rule/index.vue